import { BaseService } from 'services/baseService';
import { ContractTypeModel } from 'types/ContractType/ContractTypeModel';

class ContractTypeService extends BaseService<ContractTypeModel> {
  controllerName = 'contract-type';
}

export const contractTypeService = new ContractTypeService();
